export default "__VITE_ASSET__B9F6B$_i__"